/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { copyTextToClipboard } from "./common/Clipboard";
import "../styles/styles.scss";

const BANK_ACCOUNT_RECIPIENT = "Extra English Alicja Martiniak";
const BANK_ACCOUNT_NUMBER = "36 1140 2004 0000 3502 8025 8272";

const PaymentPage = () => (
  <div className="blurred-background legal-page payment-page">
    <Helmet>
      <title>Extra English - płatności</title>
    </Helmet>
    <div className="legal-page__container">
      <header className="legal-page__header">
        <span className="legal-page__eyebrow">Extra English</span>
        <h1>Szczegóły płatności</h1>
        <p>
          Informacje o przelewach, płatnościach online obsługiwanych przez Autopay S.A. oraz zasadach realizacji i zwrotów.
        </p>
      </header>

      <div className="payment-page__grid">
        <section className="legal-panel payment-page__bank-panel">
          <div className="legal-panel__title-row">
            <i className="fas fa-university"></i>
            <h2>Dane do przelewu</h2>
          </div>
          <div className="bank-account-row">
            <span>Odbiorca</span>
            <div className="bank-account-box bank-account-box--text">
              <strong>{BANK_ACCOUNT_RECIPIENT}</strong>
              <button type="button" aria-label="Skopiuj odbiorcę" onClick={() => copyTextToClipboard(BANK_ACCOUNT_RECIPIENT)}>
                Skopiuj
              </button>
            </div>
          </div>
          <div className="bank-account-row">
            <span>Konto bankowe</span>
            <div className="bank-account-box">
              <strong>{BANK_ACCOUNT_NUMBER}</strong>
              <button type="button" aria-label="Skopiuj numer konta" onClick={() => copyTextToClipboard(BANK_ACCOUNT_NUMBER)}>
                Skopiuj
              </button>
            </div>
          </div>
          <p className="legal-page__note">
            W tytule przelewu prosimy wpisać imię i nazwisko dziecka, nazwę grupy oraz termin zajęć.
          </p>
          <a
            href="../../resources/offer/umowa_o_nauke_angielskiego_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="legal-action-link"
          >
            <i className="far fa-file-alt"></i>
            Umowa o świadczenie usług
          </a>
        </section>

        <section className="legal-panel payment-page__online-panel">
          <div className="legal-panel__title-row">
            <i className="far fa-credit-card"></i>
            <h2>Metody płatności online</h2>
          </div>
          <p>
            Jeżeli dla danej usługi udostępniona jest płatność online, obsługa płatności jest realizowana przez Autopay S.A.
            Dostępne metody mogą obejmować szybki przelew, BLIK, płatność kartą oraz inne metody udostępnione przez operatora.
          </p>
          <img
            src="/resources/payment/autopay-blik-card-transfer-485x115.png"
            alt="Autopay - BLIK, płatności kartą i szybki przelew"
            className="autopay-payment-banner"
          />
          <div className="payment-methods payment-methods--light">
            <span>Visa</span>
            <span>Visa Electron</span>
            <span>Mastercard</span>
            <span>Mastercard Electronic</span>
            <span>Maestro</span>
          </div>
          <p className="legal-page__note">
            Extra English nie przechowuje danych kart płatniczych.
          </p>
        </section>
      </div>

      <section className="legal-panel payment-page__wide-panel">
        <div className="legal-panel__title-row">
          <i className="far fa-clock"></i>
          <h2>Realizacja i zwroty</h2>
        </div>
        <p>
          Czas realizacji zamówienia jest liczony od momentu uzyskania pozytywnej autoryzacji płatności. Zasady zwrotów i reklamacji
          opisuje <Link to="/terms">Regulamin świadczenia usług Extra English</Link>.
        </p>
      </section>
    </div>
  </div>
);

export default PaymentPage;
